// Espelha o TipoArquivoEnum do backend (serializado como número).
export var TipoArquivo;
(function (TipoArquivo) {
    TipoArquivo[TipoArquivo["Link"] = 1] = "Link";
    TipoArquivo[TipoArquivo["PdfProtegido"] = 2] = "PdfProtegido";
})(TipoArquivo || (TipoArquivo = {}));
/**
 * Indica se o arquivo é um PDF enviado pelo painel, servido somente pelo endpoint protegido.
 */
export var isPdfProtegido = function (arquivo) {
    return (arquivo === null || arquivo === void 0 ? void 0 : arquivo.tipoArquivo) === TipoArquivo.PdfProtegido && !!(arquivo === null || arquivo === void 0 ? void 0 : arquivo.id);
};
/**
 * Indica se há arquivo para exibir: link externo com URL ou PDF protegido (sem URL).
 */
export var possuiArquivo = function (arquivo) { return !!(arquivo === null || arquivo === void 0 ? void 0 : arquivo.url) || isPdfProtegido(arquivo); };
